import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  LayoutDefaultWithNamedOutletsComponent
} from 'features/common/components/layout-default-with-named-outlets/layout-default-with-named-outlets.component';

@NgModule({
  providers: [
    provideRouter([
      {
        path: 'self-onboard-customer',
        component: LayoutDefaultWithNamedOutletsComponent,
        data: {
          pageClass: 'feature-flash'
        },
        children: [
          {
            path: '',
            loadComponent: () => import('features/customer/pages/customers/self-onboard-customer/components/header/header.component').then((x) => x.HeaderComponent),
            outlet: 'header'
          },
          {
            path: '',
            loadComponent: () => import('features/common/components/footer/footer.component').then((x) => x.FooterComponent),
            outlet: 'footer',
            data: { showFreeLyLogo: true }
          },
          {
            path: '',
            children: [
              {
                path: '',
                loadComponent: () => import('./pages/self-onboard-customer/self-onboard-customer.component'),
              },
              {
                path: 'success',
                loadComponent: () => import('./pages/success/self-onboard-customer-success.component'),
              }
            ]
          },

        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class SelfOnboardCustomerRoutingModule { }
